<template>
  <div>
    <pdl-loading v-if="isProcessingCustomizationAction" :is-loading="isProcessingCustomizationAction" :page="true" />
    <customization-discard-dialog />
    <customization-save-dialog />
    <customization-share-email-dialog />
    <customization-submit-to-retailer-dialog />
    <customization-summary-dialog />
  </div>
</template>

<script>
import CustomizationDiscardDialog from '@/components/containers/buy-zone/CustomizationDiscardDialog.vue';
import CustomizationSaveDialog from '@/components/containers/buy-zone/customization/CustomizationSaveDialog.vue';
import CustomizationShareEmailDialog from '@/components/containers/buy-zone/CustomizationShareEmailDialog.vue';
import CustomizationSubmitToRetailerDialog from '@/components/containers/buy-zone/customization/CustomizationSubmitToRetailerDialog.vue';
import CustomizationSummaryDialog from '@/components/containers/buy-zone/customization/CustomizationSummaryDialog.vue';
import {PdlLoading} from '@pedal/pdl-loading';
import {mapState} from 'vuex';

export default {
  components: {
    CustomizationDiscardDialog,
    CustomizationSaveDialog,
    CustomizationShareEmailDialog,
    CustomizationSubmitToRetailerDialog,
    CustomizationSummaryDialog,
    PdlLoading,
  },
  computed: {
    ...mapState('bikeCustomization', ['isProcessingCustomizationAction']),
  },
};
</script>
